import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';

export const addUserIdInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.url.includes('/user/login')) {
    return next(req);
  }

  // Vor dem Login existiert noch kein Benutzer - dann ohne Header weiterschicken,
  // statt den Request mit einem TypeError abzubrechen.
  const institutionId = inject(AuthService).user?.one?.institutionId;
  if (!institutionId) {
    return next(req);
  }

  return next(req.clone({ headers: req.headers.append('institutionId', institutionId) }));
};
